module.exports = {
	"base": {
		"welcome": "Fáilte chuig Mulligans, %{name}!",
		"user": "Faisnéis úsáideora",
		"devices": "Gléasanna",
		"refunds": "Aisíocaíochtaí",
		"resources": "Acmhainní",
		"transactions": "Orduithe & Tuairisceáin",
		"email": "Ríomhphost",
		"password": "Pasfhocal",
		"save": "Sábháil",
		"sign-out": "Sínigh amach",
		"cancel": "Cealaigh",
		"close": "Dún",
		"learn-more": "Tuilleadh faisnéise",
		"required": "Riachtanach",
		"support": "Tacaíocht",
		"bookshelf": "Bookshelf",
		"launch": "Lainseáil",
		"download": "Íoslódáil",
		"details": "Mionsonraí",
		"cannot-be-blank": "%{field}: ní féidir é seo a fhágáil folamh.",
		"saving": "Ag sábháil...",
		"done": "Déanta",
		"failed": "Teipthe",
		"copy": "Cóipeáil"
	},
	"signin": {
		"login-failure": "Tá an seoladh ríomhphoist nó pasfhocal mícheart",
		"welcome-large": "Fáilte chuig <span class='inner'>Lárionad Cuntas %{brand}</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Sínigh isteach",
		"forgot-password": "An bhfuil dearmad déanta agat ar do phasfhocal?",
		"new-to-vst": "An é seo do chéad eispéireas le %{brand}?",
		"create-account": "Cruthaigh cuntas",
		"signing-in": "Ag síniú isteach...",
		"signin-failed": "Níor éirigh le síniú isteach"
	},
	"transactions": {
		"price": "Praghas",
		"excluded": "(Gan cáin a áireamh)",
		"quantity": "Líon",
		"confirmation#": "Uimh. dheimhnithe",
		"payment": "Íocaíocht",
		"purchased": "Ar ceannaíodh iad",
		"purchase-details": "Mionsonraí an cheannacháin",
		"subtotal": "Fo-iomlán",
		"total": "Iomlán",
		"tax": "Cáin",
		"loading": "Tá do chuid idirbheart á lódáil againn...",
		"no-purchases": "Níl aon cheannacháin agat.",
		"seller-vat": "CBL an díoltóra",
		"total-vat": "Méid iomlán %{vat} íoctha",
		"portion": "%{subTax} Cáin %{rate}%",
		"vat-disclosure": "Áirítear %{vat} leis an bpraghas",
		"purchases": "Ceannacháin",
		"refunded-items": "Míreanna aisíoctha",
		"book-title": "Teideal an leabhair",
		"refund-details": "Sonraí aisíocaíochta",
		"print-receipt": "Priontáil admháil",
		"request-refund": "Iarr ar aisíocaíocht",
		"expired": "Imithe as feidhm",
		"expires-in": "Rachaidh sé in éag an %{date}",
		"details-refund": "Sonraí & Aisíocaíocht",
		"modal": {
			"cant-refund-title": "Níl aisíocaíocht ar fáil",
			"cant-refund": "Ní féidir aisíocaíocht a fháil i leith an leabhair de bharr ceann amháin nó níos mó de na cúiseanna seo a leanas.",
			"cant-refund-1": "Amharcadh ar rómhéid den leabhar.",
			"cant-refund-2": "Ceannaíodh é breis is 14 lá ó shin.",
			"cant-refund-3": "Nochtadh do chód acmhainní ar líne.",
			"cant-refund-4": "Aisíocadh an leabhar cheana.",
			"cant-refund-5": "Rinneadh na cóid go léir a fhuascailt agus/nó a aisíoc cheana.",
			"cant-refund-6": "Tá níos mó ná 30 lá imithe thart ón dáta ceannacháin.",
			"cant-refund-support": "Má tá tú míchinnte go fóill faoi pholasaí aisíocaíochta %{brand}, déan teagmháil leis an <a href='%{support_url}' target='_blank'>bhfoireann tacaíochta</a>."
		},
		"license": {
			"perpetual": "Ní rachaidh rochtain ar líne in éag",
			"days": "%{days}: líon na laethanta rochtana"
		}
	},
	"devices": {
		"description": "Ligeann %{brand} duit <span>%{desktop}</span> ríomhaire agus <span>%{mobile}</span> gléas móibíleach/táibléad a bheith gníomhachtaithe agat ag an am céanna.",
		"loading": "Tá do chuid gléasanna á bhfáil againn :)",
		"no-active": "Níl aon ghléas gníomhachtaithe agat.",
		"deactivate": "Díghníomhachtaigh"
	},
	"user": {
		"personal-information": "Faisnéis phearsanta",
		"security-information": "Faisnéis slándála",
		"notifications": "Fógraí",
		"first-name": "Céadainm",
		"last-name": "Sloinne",
		"change-password-title": "Athraigh an pasfhocal",
		"current-password": "Pasfhocal reatha",
		"new-password": "Pasfhocal nua",
		"security-password": "Pasfhocal",
		"confirm-new-password": "Deimhnigh an pasfhocal nua",
		"security-question": "Ceist slándála",
		"security-info-change": "Athraigh",
		"question": "Ceist",
		"answer": "Freagra",
		"notifications-text": "Seol ríomhphoist chugam ó am go ham maidir le gníomhaíocht ar mo chuntas, le nuashonruithe táirge agus le tairiscintí speisialta.",
		"loading": "Tá d'fhaisnéis úsáideora á fáil ag an madra, fan nóiméad 🐶",
		"change-password-text": "Ní mór 8 gcarachtar ar a laghad, mar aon le litir chás uachtair, litir chás íochtair agus carachtar speisialta amháin, a bheith sa phasfhocal.",
		"email-locked": "Ríomhphost glasáilte",
		"email-locked-description": "Níl cead agat do sheoladh ríomhphoist a athrú.",
		"email-locked-more": "Déan teagmháil leis an riarthóir.",
		"security-question6": "Cén spórt is fearr leat?",
		"security-question7": "Cén blas uachtar reoite is fearr leat?",
		"security-question8": "Cén t-ainm atá ar an bpeata is fearr leat? ",
		"security-question9": "Nuair a bhí tú óg, cén post a theastaigh uait a bheith agat mar dhuine fásta? ",
		"security-question10": "Cén sloinne a bhí ag an múinteoir ab fhearr leat?",
		"new-password-failure": "Níl na riachtanais á gcomhlíonadh ag an bpasfhocal.",
		"confirm-password-failure": "Ní mór do na pasfhocail a bheith mar an gcéanna",
		"new-password-tooltip": "Ní mór 8 gcarachtar ar a laghad, litir chás uachtair, litir chás íochtair agus carachtar speisialta a bheith ann.",
		"enter-valid-email": "Cuir isteach seoladh ríomhphoist bailí.",
		"password-cannot-be-same": "Ní féidir an pasfhocal roimhe seo a úsáid arís.",
		"incorrect-password": "Pasfhocal mícheart",
		"complete-account": "Is cosúil go bhfuil ort <a href='%{href}'>do chuntas a chomhlánú</a>.",
		"completing-allows": "Comhlánaigh do chuntas chun leabhair a léamh as líne ar ár bhfeidhmchlár móibíleach agus chun nótaí agus sleachta aibhsithe a roinnt le cairde.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Gabhálais",
		"access-codes": "Cóid rochtana",
		"print-on-demand": "Priontáil ar éileamh",
		"check-pod": "Seiceáil roghanna clóite foilsitheora na leabhar.",
		"check-now": "Seiceáil anois",
		"loading": "Fan nóiméad, tá do chuid acmhainní á nuashonrú againn!",
		"in": "in",
		"access-code-intro": "Is cód rochtana ann ná pasfhocal a úsáidtear chun inneachar an chúrsa ar líne a rochtain. A luaithe agus a nochtar cód míre, ní bheidh tú ábalta é a sheoladh ar ais. Chun tuilleadh treoracha a fháil maidir le conas na cóid rochtana a úsáid, gabh chuig an <a href='%{support_url}' target='_blank'>Ionad Tacaíochta</a>.",
		"expires": "Rachaidh sé in éag",
		"expiration-message": "Tá treoracha ann maidir le conas an cód rochtana a úsáid.",
		"copy-fail": "Ní féidir cóipeáil. Roghnaigh an cód agus déan é a chóipeáil de láimh.",
		"launch-site": "Lainseáil an suíomh",
		"launch-book": "Lainseáil an leabhar",
		"reveal-code": "Taispeáin an cód",
		"no-resources": "Níl aon acmhainní agat.",
		"no-access-codes": "Níl aon chóid rochtana agat.",
		"no-ancillaries": "Níl aon mhíreanna gaolmhara ag gabháil leis an teideal seo",
		"name": "Ainm",
		"type": "Cineál",
		"size": "Méid",
		"download-all": "Íoslódáil gach rud",
		"back": "Siar go dtí na hacmhainní"
	},
	"refunds": {
		"states": {
			"refunded": "Aisíoctha",
			"unavailable": "Níl aisíocaíocht ar fáil"
		},
		"reasons": {
			"dropped": "D'éirigh mé as an gcúrsa",
			"wrong": "Ní hé seo an leabhar cúrsa ceart",
			"print": "Chinn mé leagan clóite a cheannach ina ionad",
			"missing": "Níl na rudaí go léir sa leabhar atá riachtanach don chúrsa (m.sh. CD, rochtain ghréasáin, físeáin)",
			"other": "Eile"
		},
		"bulk": {
			"policy": "Má chliceálaim ar an gcnaipe &quot;Cuir an aisíocaíocht i gcrích&quot; thíos, táim ag comhaontú le polasaí aisíocaíochta %{brand} <a href='%{policy_url}' target='_blank'></a>.",
			"complete": "Cuir an aisíocaíocht i gcrích",
			"view-details": "Amharc ar na sonraí aisíocaíochta",
			"success": "Tá d'aisíocaíocht iarrtha. Fan 48 uair le próiseáil.",
			"failure": "Úps - bhí fadhb ann! Theip ar an aisíocaíocht.",
			"retry": "Bain triail eile as",
			"support": "Déan teagmháil leis an lucht tacaíochta",
			"available-codes": "Na cóid atá ar fáil",
			"codes-selected": "Na cóid roghnaithe",
			"download": "Íoslódáil cóid",
			"partially-refunded": "Aisíoctha i bpáirt",
			"pick-one": "Ní mór cód amháin ar a laghad a roghnú chun aisíocaíocht a dhéanamh"
		},
		"refund": "Aisíoc",
		"all": "An bhfuil fonn ort aisíocaíocht a fháil i leith gach ruda?",
		"missing-reason": "Ní mór cúis a roghnú chun leanúint ar aghaidh",
		"missing-elaboration": "Tabhair tuilleadh sonraí",
		"policy": "Má chliceálaim ar an gcnaipe “Cuir an t-iarratas ar aisíocaíocht i gcrích” thíos, tuigim má cheannaím an ríomhthéacsleabhar %{brand} arís, nach mbeidh mé i dteideal aisíocaíocht a fháil air. Amharc ar an bpolasaí iomlán aisdúichithe.",
		"refunded": "Aisíoctha",
		"sorry": "Tá brón orainn nach raibh tú sásta leis an gceannachán.",
		"error": "Bhí fadhb ann",
		"error-explain": "Ní féidir linn an aisíocaíocht a phróiseáil. Bain triail eile as.",
		"why": "Inis dúinn cén fáth?",
		"no-refunds": "Níl aon mhíreanna aisíoctha agat.",
		"select-codes": "Roghnaigh có(i)d lena (n-)aisíoc:",
		"number": "Cá mhéad?",
		"back": "Siar go dtí na haisíocaíochtaí"
	},
	"purchases": {
		"back": "Siar go dtí na ceannacháin"
	},
	"global-bar": {
		"account": "Socruithe cuntais"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/ga.json
 ** module id = 1009
 ** module chunks = 0
 **/